import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Odata_Url, Constants } from '../../../../Constants/Constants'

import { Input, Form, Button, Tabs, Icon, Select, Switch, Spin, Table, Drawer } from 'antd';

import axios from 'axios'

const TabPane = Tabs.TabPane;
const FormItem = Form.Item;
const { TextArea } = Input;
const { Option } = Select;
const { Column } = Table

var initialcate = [];
const type_cate = ['Unused', 'Used'];

class CreateOrUpdateJobType extends Component {
    constructor() {
        super();

        this.state = {
            jobtype: {},
            category: [],
            initial_cate: [],
            select_job_category: [],
            job_category: [],
            onLoading: false,
            visible: false,
            pass_category: {},
            subcategory_select: [],
            JobTypeGroup: []
        }

        this.handleStatus = this.handleStatus.bind(this)
        this.selectType = this.selectType.bind(this)
        // this.clear = this.clear.bind(this)
        // this.save_job = this.save_job.bind(this)
        // this.onclose = this.onclose.bind(this)
    }

    componentDidMount() {
        this.setState({ onLoading: true });
        var jobtype_id = this.props.jobtype_id

        Promise.all([this.getJobtypeCategory(), this.getCategory()]).then(([jobcat, cat]) => {
            var job_list = JSON.parse(window.localStorage.getItem('PassJobtype'))
            var subcat = JSON.parse(window.localStorage.getItem('Sub_Category'))
            this.getGroup()
            var jobtype = {};
            job_list.map((l, i) => {
                if (l.PKJobTypeID === (jobtype_id + 1)) {
                    jobtype = l;
                }
                return true
            })

            let category_choosed = []
            let subcategory_select = []
            cat.map((l, i) => {
                var cat = jobcat === undefined ? undefined : jobcat.find(x => x.JobTypeId === jobtype.PKJobTypeID && x.CatId === l.PKCategoryID && x.SubCatId === null);

                if (cat === undefined) {
                    initialcate[i] = { cate_id: l.PKCategoryID, status: 0, text: 'Unused' }
                }
                else {
                    initialcate[i] = { cate_id: l.PKCategoryID, status: cat.IsActived ? 1 : 0, text: cat.IsActived ? 'Used' : 'Unused' }
                    if (cat.IsActived)
                        category_choosed.push(l.PKCategoryID)
                    l.IsRequired = cat.IsRequired
                }
                return null;
            })

            jobcat = jobcat == undefined ? [] : jobcat.filter(x => x.JobTypeId === jobtype.PKJobTypeID)

            jobcat.map((l, i) => {
                if (l.IsActived) {
                    subcategory_select.push({
                        category_id: l.CatId,
                        subcategory_id: l.SubCatId
                    })
                }
                return true
            })

            cat = cat.filter(x => x.Type_Category == jobtype.Type);

            this.setState({
                jobtype: jobtype,
                category: cat,
                subcategory: subcat,
                jobcat: jobcat,
                initial_cate: initialcate,
                category_choosed: category_choosed,
                subcategory_select: subcategory_select
            })
            this.setState({ onLoading: false });

        })
    }

    async getJobtypeCategory() {

        var Token
        let res = await axios.get(Constants.BASE_URL + 'auth/token')
            .then(async (response) => {
                Token = response.data
                let cat_res = await axios.get(
                    Odata_Url + 'OJobType_Category?$filter=IsActived eq true',
                    {
                        headers: {
                            "Authorization": "Bearer " + Token,
                        }
                    }
                )
                    .then((response) => {
                        const data = [];
                        response.data.value.forEach(function (element) {
                            data.push(element);
                        });
                        // console.log(data);
                        this.setState({
                            job_category: data
                        })
                        window.localStorage.setItem('JobType_Category', JSON.stringify(data));
                        return data;
                    },
                        (error) => {
                            console.log(error);
                            return true
                        });
                return cat_res;
            },
                (error) => {
                    console.log(error);
                    if (401 === error.response.status) {
                        window.location.href = "auth";
                    }
                    return true
                });
        return res;
    }

    async getCategory() {

        var Token
        let res = await axios.get(Constants.BASE_URL + 'auth/token')
            .then(async (response) => {
                Token = response.data
                let cat_res = await axios.get(
                    Odata_Url + 'OCategoryMD?$filter=IsActived eq true',
                    {
                        headers: {
                            "Authorization": "Bearer " + Token,
                        }
                    }
                )
                    .then((response) => {
                        const data = [];
                        response.data.value.forEach(function (element) {
                            data.push(element);
                        });
                        this.setState({
                            category_raw: data
                        })
                        return data;
                    },
                        (error) => {
                            console.log(error);
                            return true
                        });
                return cat_res;
            },
                (error) => {
                    console.log(error);
                    if (401 === error.response.status) {
                        window.location.href = "auth";
                    }
                    return true
                });
        return res;
    }

    getGroup() {
        this.getToken().then(token => {

            let tokenHeader = {
                headers: {
                    "Authorization": "Bearer " + token,
                }
            };

            axios.get(Constants.BASE_URL + 'api/Master/GetJobTypeGroup', tokenHeader).then((response) => {
                this.setState({
                    JobTypeGroup: response.data
                })
            })
        });

        
    }

    select_category(id) {

        let index = initialcate.findIndex(x => x.cate_id === id)

        if (initialcate[index].status === 0) {
            initialcate[index].status = 1
            initialcate[index].text = type_cate[1]
        } else {
            initialcate[index].status = 0
            initialcate[index].text = type_cate[0]
        }

        this.setState({
            initial_cate: initialcate,
        })
    }

    setFalseCategory() {
        initialcate.map((l, i) => {
            l.status = 0
            l.text = type_cate[0]
        })
        this.setState({
            initial_cate: initialcate,
        })
    }

    handleStatus = () => {
        let jobtype = this.state.jobtype
        let status = jobtype.IsActived
        jobtype.IsActived = !status
        this.setState({
            jobtype: jobtype
        })
    }

    handleClickOpenSubCate = (id) => {
        var cat = this.state.category_raw
        var subcat = this.state.subcategory
        var jobcat = this.state.subcategory_select
        var category = {};
        cat.map((l, i) => {
            if (l.PKCategoryID === (id + 1)) {
                category = l;
            }
        })

        var subcategory_choosed = []
        subcat.map((l, i) => {
            var subcat = jobcat === undefined ? undefined : jobcat.find(x => x.category_id == category.PKCategoryID && x.subcategory_id == l.PKSubCategoryID);
            if (subcat !== undefined)
                subcategory_choosed.push(l.PKSubCategoryID)
        })

        this.setState({
            visible: true,
            pass_category: category,
            subcategory_choosed: subcategory_choosed
        })
    }

    onSaveSubcategory = () => {
        var category = this.state.pass_category
        this.clearSubcategoryBycateId(category.PKCategoryID)
        var subcategory = this.state.subcategory_select.filter(x => x.category_id !== category.PKCategoryID)
        var subcategory_choosed = this.state.subcategory_choosed

        subcategory_choosed.map((l, i) => {
            subcategory.push({
                category_id: category.PKCategoryID,
                subcategory_id: l
            })
        })

        this.setState({
            visible: false,
            pass_category: {},
            subcategory_select: subcategory
        })
    }

    clearSubcategoryBycateId = (id) => {
        var subcategory = this.state.subcategory_select
        if (subcategory.length > 0)
            subcategory = subcategory.filter(x => x.category_id !== id)
        this.setState({
            subcategory_select: subcategory
        })
    }

    onSubCateClose = () => {
        this.setState({
            visible: false,
            pass_category: {}
        })
    }

    selectType(type) {
        var jobtype = this.state.jobtype
        this.getJobtypeCategory().then(jobcat => {
            this.setState({ onLoading: true });

            var job_list = JSON.parse(window.localStorage.getItem('Jobtype'))
            var cat = this.state.category_raw

            cat.map((l, i) => {
                var cat = jobcat === undefined ? undefined : jobcat.find(x => x.JobTypeId == jobtype.PKJobTypeID && x.CatId == l.PKCategoryID);

                if (cat === undefined) {
                    initialcate[i] = { cate_id: l.PKCategoryID, status: 0, text: 'Unused' }
                }
                else {
                    initialcate[i] = { cate_id: l.PKCategoryID, status: cat.IsActived ? 1 : 0, text: cat.IsActived ? 'Used' : 'Unused' }
                }
                return null;
            })

            cat = cat.filter(x => x.Type_Category == type);

            this.setState({
                category: cat,
                initial_cate: initialcate
            })
            this.setState({ onLoading: false });
        });
    }

    IsChangeRequiredCate = (row) => {
        let cate = this.state.category
        cate.map(l => {
            if (row.PKCategoryID === l.PKCategoryID)
                l.IsRequired = !l.IsRequired
        })
        this.setState({
            category: cate
        })
    }

    handleSubmit = (e) => {
        e.preventDefault();

        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.setState({ onLoading: true });

                var jobtype_id = this.props.jobtype_id;
                var cate = [];
                var subcategory_select = this.state.subcategory_select
                let cat = this.state.category
                let jobtype = this.state.jobtype

                initialcate.map((l, i) => {
                    if (l.status === 1) {
                        let subcate = subcategory_select.filter(x => x.category_id == l.cate_id && x.subcategory_id !== null)
                        l.sub_cat = subcate
                        l.IsRequired = cat.find(x => x.PKCategoryID === l.cate_id).IsRequired
                        cate.push(l);
                    }
                })

                var jobtype_data = {
                    jobtype_id: (jobtype_id + 1),
                    jobtype: values.JobType1,
                    jobtype_en: values.JobType_EN,
                    short_detail: values.Short_detail,
                    short_detail_en: values.Short_detail_EN,
                    type: values.Type,
                    GroupName: values.GroupName,
                    image_name: values.Image_name,
                    is_actived: values.IsActived,
                    category_list: cate
                }

                var JobType = JSON.stringify(jobtype_data)

                var uri = '';
                if (jobtype_id === 9999999999)
                    uri = "AddJobType"
                else
                    uri = "UpdateJobType"

                this.getToken().then(token => {

                    let tokenHeader = {
                        headers: {
                            "Authorization": "Bearer " + token,
                        }
                    };

                    axios.post(Constants.BASE_URL + "api/Master/" + uri, { JobType: JobType }, tokenHeader)
                        .then((response) => {
                            this.setState({
                                loading: false,
                                submit_success: true
                            })
                            this.getJobtype();
                            this.props.onclose()
                            this.setState({ onLoading: false });

                        },
                            (error) => {
                                console.log(error);
                                this.setState({
                                    loading: false
                                })
                                this.props.onclose()
                                this.setState({ onLoading: false });
                            })

                });

               
            }
        })

    }

    getJobtype() {

        var Token
        axios.get(Constants.BASE_URL + 'auth/token')
            .then((response) => {
                Token = response.data
                axios.get(
                    Odata_Url + 'OJobType?$filter=IsActived eq true',
                    {
                        headers: {
                            "Authorization": "Bearer " + Token,
                        }
                    }
                )
                    .then((response) => {
                        const data = [];
                        response.data.value.forEach(function (element) {
                            data.push(element);
                        });
                        window.localStorage.setItem('Jobtype', JSON.stringify(data));
                        this.props.generateJob()
                    },
                        (error) => {
                            console.log(error);
                        });
            },
                (error) => {
                    console.log(error);
                    if (401 === error.response.status) {
                        window.location.href = "auth";
                    }
                });
    }
    onclose() {
        this.props.onclose()
    }

    getToken() {
        var $getToken = new Promise((resolve, reject) => {
            axios.get(Constants.BASE_URL + 'auth/token').then((res) => {
                resolve(res.data);
            }).catch(err => {
                if (401 === err.response.status) {
                    window.location.href = "auth";
                }
                reject(err);
            });
        });
        return $getToken;
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 16,
                    offset: 8,
                },
            },
        }
        var { initial_cate, jobtype, category_choosed, subcategory_choosed } = this.state

        var selectedRowKeys = category_choosed
        var subSelectedRowKeys = subcategory_choosed
        const rowSelecttion = {
            onChange: (selectRowKeys, selectRow) => {
                this.setFalseCategory();
                selectRowKeys.map((l, i) => {
                    this.select_category(l)
                })
            },
            onSelect: (record, selected, selectRows) => {
                if (selected)
                    category_choosed.push(record.PKCategoryID)
                else
                    category_choosed = category_choosed.filter(x => x !== record.PKCategoryID)
                this.setState({
                    category_choosed: category_choosed
                })
            },
            onSelectAll: (selectd, selectRow) => {
                let empty_list = []
                if (selectd) {
                    selectRow.map((l, i) => {
                        empty_list.push(l.PKCategoryID)
                    })
                }
                this.setState({
                    category_choosed: empty_list
                })
            },
            selectedRowKeys,
        }

        const subRowSelecttion = {
            onChange: (selectRowKeys, selectRow) => {
                let empty_list = []
                selectRowKeys.map((l, i) => {
                    empty_list.push(l)
                })
                this.setState({
                    subcategory_choosed: empty_list
                })
            },
            onSelect: (record, selected, selectRows) => {
                if (selected)
                    subcategory_choosed.push(record.PKSubCategoryID)
                else
                    subcategory_choosed = subcategory_choosed.filter(x => x !== record.PKSubCategoryID)
                this.setState({
                    subcategory_choosed: subcategory_choosed
                })
            },
            onSelectAll: (selectd, selectRow) => {
                let empty_list = []
                if (selectd) {
                    selectRow.map((l, i) => {
                        empty_list.push(l.PKSubCategoryID)
                    })
                }
                this.setState({
                    subcategory_choosed: empty_list
                })
            },
            selectedRowKeys: subSelectedRowKeys,
        }

        return (
            <div style={{ width: "100%" }}>
                <Spin spinning={this.state.onLoading} size="large" style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }} tip="Loading...">

                    <Form onSubmit={this.handleSubmit} style={{ width: "100%" }} >
                        {
                            jobtype.PKJobTypeID && (
                                <div className="job-title">
                                    <b>{jobtype.JobType1}</b>
                                </div>
                            )
                        }

                        {
                            !jobtype.PKJobTypeID && (
                                <div className="job-title">
                                    Create or update job type
                            </div>
                            )
                        }

                        <Icon type="close" style={{ position: "absolute", right: "13px", top: "15px", cursor: "pointer" }} onClick={this.props.onclose} />
                        <Tabs style={{ marginLeft: "2px", marginRight: "2px" }} size="large">
                            <TabPane tab={<span><Icon type="setting" />Job Type Details&nbsp;</span>} key="1" tabBarStyle={{ width: "50%" }}>
                                <div style={{ textAlign: "center", fontSize: "smaller" }}>
                                    <FormItem
                                        label="JobType Name (Thai)"
                                        style={{ width: "100%", textAlign: "left" }}
                                    >
                                        {
                                            getFieldDecorator('JobType1', {
                                                initialValue: jobtype.JobType1
                                            })(
                                                <Input placeholder="JobType Name (Thai)" />
                                            )}
                                    </FormItem>
                                    <FormItem
                                        label="JobType Name (Eng)"
                                        style={{ width: "100%", textAlign: "left" }}
                                    >
                                        {
                                            getFieldDecorator('JobType_EN', {
                                                initialValue: jobtype.JobType_EN
                                            })(
                                                <Input placeholder="JobType Name (Eng)" />
                                            )}
                                    </FormItem>
                                    <FormItem
                                        label="Short detail (Thai)"
                                        style={{ width: "100%", textAlign: "left" }}
                                    >
                                        {
                                            getFieldDecorator('Short_detail', {
                                                initialValue: jobtype.Short_detail
                                            })(
                                                <TextArea maxLength={2000}
                                                    placeholder="Short detail (Thai)"
                                                    autosize={{ minRows: 2, maxRows: 6 }}
                                                />
                                            )}
                                    </FormItem>
                                    <FormItem
                                        label="Short detail (Eng)"
                                        style={{ width: "100%", textAlign: "left" }}
                                    >
                                        {
                                            getFieldDecorator('Short_detail_EN', {
                                                initialValue: jobtype.Short_detail_EN
                                            })(
                                                <TextArea maxLength={2000}
                                                    placeholder="Short detail (Eng)"
                                                    autosize={{ minRows: 2, maxRows: 6 }}
                                                />
                                            )}
                                    </FormItem>
                                    <FormItem
                                        label="Type"
                                        style={{ width: "100%", textAlign: "left" }}
                                    >
                                        {
                                            getFieldDecorator('Type', {
                                                initialValue: jobtype.Type
                                            })(
                                                <Select
                                                    showSearch
                                                    style={{ width: "100%" }}
                                                    placeholder="Select type"
                                                    onChange={this.selectType}
                                                >
                                                    <Option value="factory">Factory</Option>
                                                    <Option value="office">Office</Option>
                                                </Select>
                                            )}
                                    </FormItem>
                                    <FormItem
                                        label="Group"
                                        style={{ width: "100%", textAlign: "left" }}
                                    >
                                        {
                                            getFieldDecorator('GroupName', {
                                                initialValue: jobtype.GroupName
                                            })(
                                                <Select
                                                    showSearch
                                                    style={{ width: "100%" }}
                                                    placeholder="Select Group"
                                                    onChange={this.selectGroup}
                                                >
                                                    {
                                                        this.state.JobTypeGroup.map(l => {
                                                            return (
                                                                <Option value={l.value}>{l.text}</Option>
                                                            )
                                                        })
                                                    }
                                                </Select>
                                            )}
                                    </FormItem>
                                    <FormItem
                                        label="Image Name"
                                        style={{ width: "100%", textAlign: "left" }}
                                    >
                                        {
                                            getFieldDecorator('Image_name', {
                                                initialValue: jobtype.Image_name
                                            })(
                                                <Input placeholder="ex: icon.png" />
                                            )}
                                    </FormItem>
                                    <FormItem
                                        label="Status"
                                        style={{ width: "100%", textAlign: "left" }}
                                    >
                                        {
                                            getFieldDecorator('IsActived', {
                                                initialValue: jobtype.IsActived
                                            })(
                                                <Switch
                                                    unCheckedChildren="Inactive"
                                                    checkedChildren="Active"
                                                    //defaultChecked={jobtype.IsActived}
                                                    onClick={this.handleStatus}
                                                    checked={jobtype.IsActived}
                                                ></Switch>

                                            )}
                                    </FormItem>
                                </div>
                            </TabPane>
                            <TabPane tab={<span><Icon type="home" />Category</span>} key="2" tabBarStyle={{ width: "50%" }}>
                                <Table
                                    rowKey={record => record.PKCategoryID}
                                    rowSelection={rowSelecttion}
                                    dataSource={this.state.category}
                                >
                                    <Column
                                        title=''
                                        dataIndex='Image_name'
                                        width={50}
                                        render={(data) => (
                                            <img src={"/images/" + data} style={{ borderRadius: "30%", filter: "grayscale(100%)", objectFit: "contain", height: '25px' }} />
                                        )}
                                    />
                                    <Column
                                        title='Name (Thai)'
                                        dataIndex='Category_Name'
                                    />
                                    <Column
                                        title='Name (Eng)'
                                        dataIndex='Category_Name_EN'
                                    />
                                    <Column
                                        title='Require'
                                        dataIndex='IsRequired'
                                        render={(d, row) => (
                                            <Switch defaultChecked={d} onChange={() => this.IsChangeRequiredCate(row)} />
                                        )}
                                    />
                                    <Column
                                        title='Subcategory'
                                        width={105}
                                        align='center'
                                        render={(data, row) => (
                                            <div>
                                                <a href="javascript:;" onClick={() => this.handleClickOpenSubCate(row.PKCategoryID - 1)}>
                                                    <Icon type={"select"} style={{ fontSize: "17px" }} />
                                                </a>
                                            </div>
                                        )}
                                    />

                                </Table>

                            </TabPane>
                        </Tabs>

                        <div style={{ width: "100%", marginTop: "10px" }}>
                            <FormItem style={{ width: "100%", textAlign: "center" }}>
                                <Button className="button-save-category" htmlType="submit" style={{ fontSize: "18px", width: "30%", height: "48px", borderRadius: "10px", outline: "none", backgroundColor: "rgb(0,152,139)", color: "white" }}>
                                    Save
                            </Button>
                            </FormItem>
                        </div>
                    </Form>
                    <Drawer
                        title={'Choose subcategory for ' + this.state.pass_category.Category_Name}
                        placement='top'
                        visible={this.state.visible}
                        onClose={this.onSubCateClose}
                        closable={false}
                        height='100%'
                        destroyOnClose={true}
                    >
                        <Table
                            rowKey={record => record.PKSubCategoryID}
                            rowSelection={subRowSelecttion}
                            dataSource={this.state.subcategory}
                            showHeader={false}
                            pagination={{ pageSize: 8 }}
                        >
                            <Column
                                title='Name (Thai)'
                                dataIndex='SubCategory_Name'
                            />
                            <Column
                                title='Name (Eng)'
                                dataIndex='SubCategory_Name_EN'
                            />
                        </Table>

                        <div
                            style={{
                                position: 'absolute',
                                left: 0,
                                bottom: 0,
                                width: '100%',
                                borderTop: '1px solid #e9e9e9',
                                padding: '10px 16px',
                                background: '#fff',
                                textAlign: 'right',
                            }}
                        >
                            <Button onClick={this.onSaveSubcategory} type="primary" style={{ marginRight: 8 }}>Save</Button>
                            <Button onClick={this.onSubCateClose}>Cancel</Button>

                        </div>
                    </Drawer>
                </Spin>
            </div>
        )
    }
}

const mapStatetoProps = (state) => {
    return {
        detail: state.detail,
        authen: state.authen,
        detailMyOb: state.detailMyOb,
        set_checklist: state.set_checklist
    }
}
const mapDispatchProps = (dispatch) => {
    return {
        SET_IMAGE_CATEGORY: (values) => {
            dispatch({
                type: "SET_IMAGE_JOBTYPE",
                upload: values
            })
        },
    }
}

const Newobservation_Checklist_Category = Form.create()(CreateOrUpdateJobType);

export default connect(mapStatetoProps, mapDispatchProps)(Newobservation_Checklist_Category)